import React, { Component, useState } from "react";
import { Row, Container } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import AppRoute from "../AppRoute";
import { AuthProvider, useAuthState } from "../Context";
import { authRoutes } from "../Routes";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Link,
  useLocation
} from "react-router-dom";

import SideBar from "../components/Menu/SideBar";
import NavBar from "../components/Menu/NavBar";
import classNames from "classnames";
import DashboardPage from "../pages/DashboardPage";

export default class AuthLayout extends Component {
  constructor(props) {
    super(props);

    // Moblie first
    this.state = {
      isOpen: false,
      isMobile: true
    };

    this.previousWidth = -1;
  }

  updateWidth() {
    const width = window.innerWidth;
    const widthLimit = 576;
    const isMobile = width <= widthLimit;
    const wasMobile = this.previousWidth <= widthLimit;

    if (isMobile !== wasMobile) {
      this.setState({
        isOpen: !isMobile
      });
    }

    this.previousWidth = width;
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth.bind(this));
  }

  render() {
    const { component: C, history, match = {} } = this.props;
    const userDetails = {};
    return (
      <AuthProvider>
        <BrowserRouter>
          <RouteDispatcher />
        </BrowserRouter>
      </AuthProvider>
    );
  }
}

export function RouteDispatcher(props) {
  const [isOpen, setOpen] = useState({});
  const authContext = useAuthState(); //read user de

  const { userDetails = {} } = authContext;
  const {
    login,
    email,
    token,
    verification = 0,
    validationToken
  } = userDetails;

  console.log({ userDetails });

  const toggle = () => {
    setOpen(!isOpen);
  };

  const location = useLocation();

  // return <p>{verification}</p>;
  return (
    <div className="wrapper">
      <TransitionGroup>
        <CSSTransition key={location.pathname} classNames="slide" timeout={0}>
          <Container
            fluid
            className={classNames("container-wrapper", {
              "is-open": isOpen
            })}
          >
            <Toaster />
            <Routes location={location}>
              {authRoutes.map(({ component: C, path, isPrivate, ...rest }) => {
                if (isPrivate && !token)
                  return (
                    <Route
                      path={path}
                      element={
                        <React.Fragment>
                          <Navigate replace to={{ pathname: "/login" }} />
                        </React.Fragment>
                      }
                      {...rest}
                    />
                  );

                if (isPrivate && token && verification === 0)
                  return (
                    <Route
                      path={path}
                      element={
                        <React.Fragment>
                          <Navigate
                            replace
                            to={{ pathname: `/validate/${validationToken}` }}
                          />
                        </React.Fragment>
                      }
                      {...rest}
                    />
                  );

                if (
                  (/\/validate/.test(path) &&
                    verification === 1 &&
                    path === "/login" &&
                    token &&
                    verification === 1) ||
                  (/\/validate/.test(path) && verification === 1) ||
                  (path === "/login" && token && verification === 1)
                )
                  return (
                    <Route
                      path={path}
                      element={
                        <React.Fragment>
                          <Navigate replace to={{ pathname: "/dashboard" }} />
                        </React.Fragment>
                      }
                      {...rest}
                    />
                  );

                return <Route path={path} element={<C />} {...rest} />;
              })}
            </Routes>
          </Container>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}
